import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const SUPABASE_STORAGE_KEY = 'gd-supabase-auth';

export const hasSupabaseConfig = Boolean(supabaseUrl && supabaseAnonKey);

export function clearSupabaseSessionStorage() {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(SUPABASE_STORAGE_KEY);
  window.sessionStorage.removeItem(SUPABASE_STORAGE_KEY);
}

export const supabase = hasSupabaseConfig
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        detectSessionInUrl: true,
        persistSession: true,
        storageKey: SUPABASE_STORAGE_KEY,
      },
    })
  : null;
